var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      attrs: {
        title: "Đổi mật khẩu",
        visible: _vm.dialogVisible,
        width: "600px",
        "before-close": _vm.closeDialog,
        "close-on-click-modal": false,
        "custom-class": "change-password-dialog",
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
      },
    },
    [
      _c(
        "el-form",
        {
          ref: "passwordData",
          staticClass: "change-password-form",
          attrs: {
            "label-width": "160px",
            model: _vm.passwordData,
            "label-position": "left",
            rules: _vm.rules,
          },
        },
        [
          _c("div", { staticClass: "change-password-content" }, [
            _c(
              "div",
              { staticClass: "password-panel" },
              [
                _c("div", { staticClass: "password-panel-head" }, [
                  _c("div", { staticClass: "panel-icon" }, [
                    _c("i", { staticClass: "el-icon-lock" }),
                  ]),
                  _c("div", { staticClass: "panel-text" }, [
                    _c("p", { staticClass: "panel-title" }, [
                      _vm._v("Cập nhật mật khẩu"),
                    ]),
                    _c("p", { staticClass: "panel-subtitle" }, [
                      _vm._v(
                        "Vui lòng nhập đầy đủ thông tin để đảm bảo an toàn cho tài khoản của bạn."
                      ),
                    ]),
                  ]),
                ]),
                _c(
                  "el-form-item",
                  { attrs: { label: "Mật khẩu cũ", prop: "oldPassword" } },
                  [
                    _c("el-input", {
                      attrs: {
                        "prefix-icon": "el-icon-lock",
                        placeholder: "Nhập mật khẩu cũ",
                        clearable: "",
                        "show-password": "",
                      },
                      nativeOn: {
                        keyup: function ($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          )
                            return null
                          return _vm.submitForm.apply(null, arguments)
                        },
                      },
                      model: {
                        value: _vm.passwordData.oldPassword,
                        callback: function ($$v) {
                          _vm.$set(_vm.passwordData, "oldPassword", $$v)
                        },
                        expression: "passwordData.oldPassword",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: "Mật khẩu mới", prop: "password" } },
                  [
                    _c("el-input", {
                      attrs: {
                        "prefix-icon": "el-icon-lock",
                        placeholder: "Nhập mật khẩu mới",
                        clearable: "",
                        "show-password": "",
                      },
                      nativeOn: {
                        keyup: function ($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          )
                            return null
                          return _vm.submitForm.apply(null, arguments)
                        },
                      },
                      model: {
                        value: _vm.passwordData.password,
                        callback: function ($$v) {
                          _vm.$set(_vm.passwordData, "password", $$v)
                        },
                        expression: "passwordData.password",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      label: "Xác nhận mật khẩu",
                      prop: "confirmPassword",
                    },
                  },
                  [
                    _c("el-input", {
                      attrs: {
                        "prefix-icon": "el-icon-lock",
                        placeholder: "Nhập lại mật khẩu mới",
                        clearable: "",
                        "show-password": "",
                      },
                      nativeOn: {
                        keyup: function ($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          )
                            return null
                          return _vm.submitForm.apply(null, arguments)
                        },
                      },
                      model: {
                        value: _vm.passwordData.confirmPassword,
                        callback: function ($$v) {
                          _vm.$set(_vm.passwordData, "confirmPassword", $$v)
                        },
                        expression: "passwordData.confirmPassword",
                      },
                    }),
                  ],
                  1
                ),
                _c("div", { staticClass: "password-note" }, [
                  _c("i", { staticClass: "el-icon-info" }),
                  _c("span", [
                    _vm._v(
                      "Mật khẩu cần có ít nhất 6 ký tự và nên kết hợp chữ, số để tăng bảo mật."
                    ),
                  ]),
                ]),
              ],
              1
            ),
          ]),
        ]
      ),
      _c(
        "span",
        {
          staticClass: "dialog-footer change-password-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "el-button",
            {
              staticClass: "btn-cancel",
              attrs: { type: "danger", size: "medium" },
              on: { click: _vm.closeDialogByButton },
            },
            [
              _c("i", { staticClass: "el-icon-circle-close" }),
              _c("span", [_vm._v("Đóng")]),
            ]
          ),
          _c(
            "el-button",
            {
              staticClass: "btn-save",
              attrs: {
                type: "success",
                size: "medium",
                loading: _vm.loadingButton,
                mini: "",
              },
              on: { click: _vm.submitForm },
            },
            [
              _c("i", { staticClass: "el-icon-circle-check" }),
              _c("span", [_vm._v("Lưu")]),
            ]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }